"use client";

import { useEffect } from "react";
import FooterLink from "./FooterLink";
import FooterLocation from "./FooterLocation";
// import { Biryani } from "next/font/google";

import { useSelector, useDispatch } from "react-redux";
import { fetchFooter } from "../../store/footerSlice";
import type { RootState, AppDispatch } from "../../store/store";

// const biryani = Biryani({
//   subsets: ["latin"],
//   weight: ["200", "300", "400", "600", "700", "800", "900"],
// });

const Footer = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { data, error } = useSelector((state: RootState) => state.footer);
  useEffect(() => {
    if (!data?.footerNewDesign?.id) dispatch(fetchFooter());
  }, [data, dispatch]);
  const footerData = data?.footerNewDesign
  if (error) return <></>;

  return (
    <footer className={`bg-background-dark`}>
      <div className="container">
        <div className="xl:pt-[80px] pt-[64px] pb-[55px]">
            <FooterLocation
            image={data?.logo?.data?.attributes?.url ?? ""}
            offices={footerData?.offices ?? []}
            label={footerData?.label ?? ""}
            CIN={footerData?.CIN ?? ""}
            GSTIN={footerData?.GSTIN ?? ""}
          />
          <FooterLink
            columns={footerData?.footerColumns ?? []}
            socialNetworks={footerData?.socialNetworks ?? []}
            copy_write_text={footerData?.copy_write_text ?? ""}
            pricacy_policy_link={footerData?.pricacy_policy_link ?? ""}
            terms_link={footerData?.terms_link ?? ""}
          />
        </div>
      </div>
    </footer>
  );
};
export default Footer;